import { render } from "./ResourceFormInput.vue?vue&type=template&id=1e482f90&ts=true"
import script from "./ResourceFormInput.vue?vue&type=script&lang=ts"
export * from "./ResourceFormInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__